<template>
  <div class="calico-credit-box-scale-page">
    <div class="calico-credit-box-scale-container">
      <CalicoCreditBoxScale
        label="####"
        :score="1"
        low-label="Low"
        med-label="Med"
        high-label="High"
      />
      <CalicoCreditBoxScale
        label="####"
        :score="2"
        low-label="Low"
        med-label="Med"
        high-label="High"
      />
      <CalicoCreditBoxScale
        label="####"
        :score="9"
        low-label="Low"
        med-label="Med"
        high-label="High"
      />
      <CalicoCreditBoxScale
        label="####"
        :score="12"
        low-label="Low"
        med-label="Med"
        high-label="High"
      />
      <CalicoCreditBoxScale
        label="####"
        :score="15"
        low-label="Low"
        med-label="Med"
        high-label="High"
      />
      <CalicoCreditBoxScale
        label="####"
        :score="18"
        low-label="Low"
        med-label="Med"
        high-label="High"
      />
      <CalicoCreditBoxScale
        label="####"
        :score="7"
        low-label="Low"
        med-label="Med"
        high-label="High"
      />
    </div>
  </div>
</template>
  
<script lang="js">
  import CalicoCreditBoxScale from '@/components/calico/creditBoxScale/index.vue'
  
  export default {
    name: 'CalicoCreditBoxScalePage',
    components: {
      CalicoCreditBoxScale
    }
  }
</script>
  
<style lang="scss">
  .calico-credit-box-scale-page {
    display: flex;
    
    .calico-credit-box-scale-container {
      @include stack-space($space-large);
      @include inset-space($space-medium);
      width: 403px;
    }
  }
</style>
  